import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './router/permission'
// import VConsole from 'vconsole'

// const vConsole = new VConsole
import Header from '@/components/common/header/header'
Vue.component('Header', Header)
import HeaderVertical from '@/components/common/header_vertical/header_vertical'
Vue.component('HeaderVertical', HeaderVertical)
import Vant from 'vant';
import 'vant/lib/index.css';
import { Toast,Area } from 'vant';
Vue.use(Vant)
Vue.use(Area)
// Vue.use(vConsole)
Vue.config.productionTip = false
Vue.prototype.$toast = Toast

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
